import { render, staticRenderFns } from "./PreserveWhitespace.vue?vue&type=template&id=5ff08ae0&scoped=true&"
import script from "./PreserveWhitespace.vue?vue&type=script&lang=js&"
export * from "./PreserveWhitespace.vue?vue&type=script&lang=js&"
import style0 from "./PreserveWhitespace.vue?vue&type=style&index=0&id=5ff08ae0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff08ae0",
  null
  
)

export default component.exports